/**
 * ABGELEITET aus server/werkzeug-register-daten.ts — nicht von Hand ändern.
 * Neu schreiben: npx tsx scripts/karten-politik-erzeugen.ts (Wächter: tests/server/karten-politik.test.ts).
 */
import type { Familie, KartenPolitik } from "./karten-anzeige.js";

export const KARTEN_POLITIK_DATEN: Readonly<Record<string, { karte: KartenPolitik; familie: Familie }>> = {
  _geraet_bestimmen: { karte: "stumm", familie: "mac" },
  ablage_in_konfig: { karte: "karte", familie: "einstellung" },
  abspielen: { karte: "karte", familie: "medien" },
  achtsamkeit_spiegel: { karte: "schritt", familie: "koerper" },
  alltag_detail: { karte: "karte", familie: "alltag" },
  alltag_lesen: { karte: "karte", familie: "alltag" },
  alltag_search: { karte: "schritt", familie: "alltag" },
  alltag_steuern: { karte: "karte", familie: "alltag" },
  amazon_search: { karte: "karte", familie: "web" },
  analyze_video: { karte: "karte", familie: "web" },
  anker_anlegen: { karte: "karte", familie: "gedaechtnis" },
  anker_bearbeiten: { karte: "karte", familie: "gedaechtnis" },
  anker_liste: { karte: "karte", familie: "gedaechtnis" },
  anker_zeigen: { karte: "karte", familie: "gedaechtnis" },
  anruf_jetzt: { karte: "karte", familie: "kontakte" },
  antwortmodus_setzen: { karte: "schritt", familie: "einstellung" },
  app_neu_laden: { karte: "karte", familie: "einstellung" },
  ask_confirm: { karte: "karte", familie: "system" },
  attach_file: { karte: "karte", familie: "datei" },
  aussprache_merken: { karte: "schritt", familie: "einstellung" },
  biography_entity_lookup: { karte: "schritt", familie: "gedaechtnis" },
  biography_timeline: { karte: "schritt", familie: "gedaechtnis" },
  blender_aufsetzen: { karte: "karte", familie: "blender" },
  blender_bild: { karte: "schritt", familie: "blender" },
  blender_freigabe_zuruecknehmen: { karte: "karte", familie: "blender" },
  blender_herde_stellen: { karte: "karte", familie: "blender" },
  blender_nahaufnahme: { karte: "schritt", familie: "blender" },
  blender_objekt_stellen: { karte: "karte", familie: "blender" },
  blender_oeffnen: { karte: "schritt", familie: "blender" },
  blender_pruefen: { karte: "schritt", familie: "blender" },
  blender_python: { karte: "karte", familie: "blender" },
  blender_render: { karte: "karte", familie: "blender" },
  blender_speichern: { karte: "karte", familie: "blender" },
  blender_szene: { karte: "schritt", familie: "blender" },
  book_compile: { karte: "karte", familie: "datei" },
  browser_ablauf: { karte: "karte", familie: "browser" },
  browser_click: { karte: "schritt", familie: "browser" },
  browser_close_tab: { karte: "schritt", familie: "browser" },
  browser_drag: { karte: "schritt", familie: "browser" },
  browser_feld_ablegen: { karte: "schritt", familie: "browser" },
  browser_form_fill: { karte: "schritt", familie: "browser" },
  browser_form_overview: { karte: "schritt", familie: "browser" },
  browser_form_submit: { karte: "schritt", familie: "browser" },
  browser_get_active_tab: { karte: "schritt", familie: "browser" },
  browser_get_page_html: { karte: "schritt", familie: "browser" },
  browser_get_page_text: { karte: "schritt", familie: "browser" },
  browser_get_selection: { karte: "schritt", familie: "browser" },
  browser_hover: { karte: "schritt", familie: "browser" },
  browser_keypress: { karte: "schritt", familie: "browser" },
  browser_list_tabs: { karte: "schritt", familie: "browser" },
  browser_open_url: { karte: "schritt", familie: "browser" },
  browser_press_key: { karte: "schritt", familie: "browser" },
  browser_screenshot: { karte: "schritt", familie: "browser" },
  browser_scroll: { karte: "schritt", familie: "browser" },
  browser_switch_tab: { karte: "schritt", familie: "browser" },
  browser_tab_context: { karte: "schritt", familie: "browser" },
  browser_type: { karte: "schritt", familie: "browser" },
  browser_upload: { karte: "karte", familie: "browser" },
  calendar_create: { karte: "karte", familie: "kalender" },
  calendar_delete: { karte: "karte", familie: "kalender" },
  calendar_list: { karte: "karte", familie: "kalender" },
  calendar_update: { karte: "karte", familie: "kalender" },
  call: { karte: "karte", familie: "kontakte" },
  changelog: { karte: "schritt", familie: "system" },
  chat_history_search: { karte: "schritt", familie: "gedaechtnis" },
  claude_task: { karte: "karte", familie: "mac" },
  claude_task_server: { karte: "karte", familie: "system" },
  connect_verlauf: { karte: "karte", familie: "system" },
  contact_call: { karte: "karte", familie: "kontakte" },
  contact_create: { karte: "karte", familie: "kontakte" },
  contact_delete: { karte: "karte", familie: "kontakte" },
  contact_find: { karte: "karte", familie: "kontakte" },
  contact_list: { karte: "karte", familie: "kontakte" },
  contact_update: { karte: "karte", familie: "kontakte" },
  current_time: { karte: "stumm", familie: "system" },
  day_note: { karte: "stumm", familie: "gedaechtnis" },
  deep_research: { karte: "karte", familie: "web" },
  deliver_text: { karte: "karte", familie: "datei" },
  dns_add: { karte: "karte", familie: "webseite" },
  dns_delete: { karte: "karte", familie: "webseite" },
  dns_list: { karte: "karte", familie: "webseite" },
  dns_update: { karte: "karte", familie: "webseite" },
  dns_zones: { karte: "schritt", familie: "webseite" },
  docs_append: { karte: "karte", familie: "datei" },
  docs_create: { karte: "karte", familie: "datei" },
  docs_find: { karte: "schritt", familie: "datei" },
  docs_read: { karte: "schritt", familie: "datei" },
  docs_replace: { karte: "karte", familie: "datei" },
  drive_create_folder: { karte: "karte", familie: "datei" },
  drive_move: { karte: "karte", familie: "datei" },
  drive_search: { karte: "karte", familie: "datei" },
  drive_upload: { karte: "karte", familie: "datei" },
  drucksache_erstellen: { karte: "karte", familie: "datei" },
  edit_image: { karte: "karte", familie: "medien" },
  einstellung_aendern: { karte: "karte", familie: "einstellung" },
  entwickler_bestellen: { karte: "schritt", familie: "system" },
  entwickler_nachricht: { karte: "karte", familie: "system" },
  entwickler_postfach: { karte: "karte", familie: "system" },
  entwickler_warten: { karte: "karte", familie: "system" },
  environment_correlate: { karte: "karte", familie: "koerper" },
  environment_history: { karte: "karte", familie: "koerper" },
  erinnern: { karte: "schritt", familie: "gedaechtnis" },
  essence_mirror: { karte: "karte", familie: "koerper" },
  expense_analyze_upload: { karte: "karte", familie: "rechnung" },
  expense_create: { karte: "karte", familie: "rechnung" },
  expense_list: { karte: "karte", familie: "rechnung" },
  expense_search: { karte: "karte", familie: "rechnung" },
  expense_stats: { karte: "karte", familie: "rechnung" },
  faktura_article_create: { karte: "karte", familie: "rechnung" },
  faktura_articles: { karte: "schritt", familie: "rechnung" },
  faktura_customer_create: { karte: "karte", familie: "rechnung" },
  faktura_customer_get: { karte: "schritt", familie: "rechnung" },
  faktura_customer_update: { karte: "karte", familie: "rechnung" },
  faktura_customers: { karte: "schritt", familie: "rechnung" },
  faktura_invoice_clone: { karte: "karte", familie: "rechnung" },
  faktura_invoice_create: { karte: "karte", familie: "rechnung" },
  faktura_invoice_delete: { karte: "karte", familie: "rechnung" },
  faktura_invoice_get: { karte: "karte", familie: "rechnung" },
  faktura_invoice_item_add: { karte: "schritt", familie: "rechnung" },
  faktura_invoice_item_delete: { karte: "schritt", familie: "rechnung" },
  faktura_invoice_item_update: { karte: "schritt", familie: "rechnung" },
  faktura_invoice_items_list: { karte: "schritt", familie: "rechnung" },
  faktura_invoice_paid: { karte: "karte", familie: "rechnung" },
  faktura_invoice_pdf: { karte: "karte", familie: "rechnung" },
  faktura_invoice_search: { karte: "karte", familie: "rechnung" },
  faktura_invoice_send: { karte: "karte", familie: "rechnung" },
  faktura_invoice_update: { karte: "karte", familie: "rechnung" },
  faktura_mahnung: { karte: "karte", familie: "rechnung" },
  faktura_recurring_generate: { karte: "karte", familie: "rechnung" },
  faktura_recurring_list: { karte: "karte", familie: "rechnung" },
  faktura_stats: { karte: "karte", familie: "rechnung" },
  flight_search: { karte: "karte", familie: "reise" },
  fokus_videos: { karte: "karte", familie: "medien" },
  forms_add_question: { karte: "karte", familie: "datei" },
  forms_create: { karte: "karte", familie: "datei" },
  forms_get_info: { karte: "schritt", familie: "datei" },
  forms_get_responses: { karte: "karte", familie: "datei" },
  gedaechtnis_bestaetigen: { karte: "schritt", familie: "gedaechtnis" },
  gedaechtnis_herkunft: { karte: "karte", familie: "gedaechtnis" },
  gedaechtnis_selbsttest: { karte: "schritt", familie: "gedaechtnis" },
  gegenprobe: { karte: "karte", familie: "system" },
  generate_image: { karte: "karte", familie: "medien" },
  generate_music: { karte: "karte", familie: "medien" },
  geraet_waehlen: { karte: "schritt", familie: "mac" },
  gespraech_beenden: { karte: "stumm", familie: "system" },
  glocke_hinterlegen: { karte: "schritt", familie: "gedaechtnis" },
  gmail_anhang_lesen: { karte: "karte", familie: "mail" },
  gmail_draft_create: { karte: "karte", familie: "mail" },
  gmail_draft_send: { karte: "karte", familie: "mail" },
  gmail_drafts_list: { karte: "karte", familie: "mail" },
  gmail_read_message: { karte: "karte", familie: "mail" },
  gmail_search: { karte: "karte", familie: "mail" },
  gmail_send: { karte: "karte", familie: "mail" },
  handlungen_nachsehen: { karte: "schritt", familie: "shell" },
  heavy_task: { karte: "karte", familie: "system" },
  human_design: { karte: "karte", familie: "koerper" },
  human_design_connection: { karte: "karte", familie: "koerper" },
  ical_list: { karte: "karte", familie: "kalender" },
  journal_zaehlung: { karte: "schritt", familie: "shell" },
  karten_lesen: { karte: "stumm", familie: "gedaechtnis" },
  lange_texte: { karte: "schritt", familie: "gedaechtnis" },
  lauf_warten: { karte: "schritt", familie: "system" },
  live_translate: { karte: "karte", familie: "web" },
  mac_anbindungen: { karte: "schritt", familie: "mac" },
  mac_applescript: { karte: "karte", familie: "mac" },
  mac_bedienung_klicken: { karte: "schritt", familie: "mac" },
  mac_bedienung_lesen: { karte: "schritt", familie: "mac" },
  mac_clipboard: { karte: "karte", familie: "mac" },
  mac_dateien: { karte: "karte", familie: "mac" },
  mac_dateien_aendern: { karte: "karte", familie: "mac" },
  mac_erinnerungen: { karte: "karte", familie: "mac" },
  mac_fenster_bedienen: { karte: "schritt", familie: "mac" },
  mac_fenster_lesen: { karte: "schritt", familie: "mac" },
  mac_finder_reveal: { karte: "karte", familie: "mac" },
  mac_kalender: { karte: "karte", familie: "mac" },
  mac_keynote_present: { karte: "karte", familie: "mac" },
  mac_kurzbefehle: { karte: "karte", familie: "mac" },
  mac_mail_compose: { karte: "karte", familie: "mac" },
  mac_mitteilung: { karte: "karte", familie: "mac" },
  mac_music: { karte: "karte", familie: "mac" },
  mac_notes_append: { karte: "karte", familie: "mac" },
  mac_notes_create: { karte: "karte", familie: "mac" },
  mac_notes_search: { karte: "karte", familie: "mac" },
  mac_notizen: { karte: "karte", familie: "mac" },
  mac_numbers_table: { karte: "karte", familie: "mac" },
  mac_pages_doc: { karte: "karte", familie: "mac" },
  mac_programme: { karte: "karte", familie: "mac" },
  mac_reminders_create: { karte: "karte", familie: "mac" },
  mac_reminders_list: { karte: "karte", familie: "mac" },
  mac_rueckgaengig: { karte: "karte", familie: "mac" },
  mac_safari_open: { karte: "karte", familie: "mac" },
  mac_sicherung: { karte: "karte", familie: "mac" },
  mac_spotlight_search: { karte: "karte", familie: "mac" },
  mac_system_volume: { karte: "karte", familie: "mac" },
  mac_telegram: { karte: "karte", familie: "mac" },
  mac_zwischenablage: { karte: "karte", familie: "mac" },
  make_pdf: { karte: "karte", familie: "datei" },
  mandat_anfragen: { karte: "karte", familie: "system" },
  mediathek_suche: { karte: "karte", familie: "datei" },
  memory_delete: { karte: "schritt", familie: "gedaechtnis" },
  memory_save: { karte: "schritt", familie: "gedaechtnis" },
  memory_search: { karte: "schritt", familie: "gedaechtnis" },
  messwerte: { karte: "schritt", familie: "shell" },
  modell_importieren: { karte: "karte", familie: "modelle" },
  modell_suchen: { karte: "schritt", familie: "modelle" },
  morgenmeditation: { karte: "karte", familie: "medien" },
  morse_merkwort: { karte: "schritt", familie: "lernen" },
  morse_stand: { karte: "schritt", familie: "lernen" },
  narrate_to_mp3: { karte: "karte", familie: "datei" },
  newsletter_aendern: { karte: "karte", familie: "newsletter" },
  newsletter_aus_vorlage: { karte: "karte", familie: "newsletter" },
  newsletter_create: { karte: "karte", familie: "newsletter" },
  newsletter_groups: { karte: "schritt", familie: "newsletter" },
  newsletter_lesen: { karte: "schritt", familie: "newsletter" },
  newsletter_recipients: { karte: "schritt", familie: "newsletter" },
  newsletter_send: { karte: "karte", familie: "newsletter" },
  newsletter_send_test: { karte: "karte", familie: "newsletter" },
  newsletter_senders: { karte: "schritt", familie: "newsletter" },
  newsletter_stats: { karte: "karte", familie: "newsletter" },
  newsletter_status: { karte: "karte", familie: "newsletter" },
  newsletter_templates: { karte: "schritt", familie: "newsletter" },
  numbers_table_to_mail: { karte: "karte", familie: "mac" },
  nutzer_lage: { karte: "karte", familie: "system" },
  oebb_journey: { karte: "karte", familie: "reise" },
  open_app: { karte: "karte", familie: "einstellung" },
  open_url: { karte: "karte", familie: "web" },
  open_view: { karte: "karte", familie: "einstellung" },
  panel_verbindung: { karte: "schritt", familie: "webseite" },
  phone_play: { karte: "karte", familie: "medien" },
  play_music: { karte: "karte", familie: "medien" },
  profile_get: { karte: "schritt", familie: "einstellung" },
  profile_update: { karte: "karte", familie: "einstellung" },
  project_create: { karte: "schritt", familie: "datei" },
  project_delete: { karte: "karte", familie: "datei" },
  project_file_create: { karte: "schritt", familie: "datei" },
  project_file_delete: { karte: "schritt", familie: "datei" },
  project_file_get: { karte: "stumm", familie: "datei" },
  project_file_list: { karte: "stumm", familie: "datei" },
  project_file_move: { karte: "karte", familie: "datei" },
  project_file_update: { karte: "schritt", familie: "datei" },
  project_link: { karte: "schritt", familie: "datei" },
  project_list: { karte: "stumm", familie: "datei" },
  project_set_active: { karte: "schritt", familie: "datei" },
  project_unlink: { karte: "karte", familie: "datei" },
  project_update: { karte: "karte", familie: "datei" },
  read_file: { karte: "schritt", familie: "datei" },
  read_url: { karte: "schritt", familie: "web" },
  research_directory: { karte: "karte", familie: "web" },
  route_directions: { karte: "karte", familie: "reise" },
  schedule_task: { karte: "karte", familie: "kalender" },
  schluessel_ablegen: { karte: "schritt", familie: "einstellung" },
  screen_ablauf: { karte: "karte", familie: "mac" },
  screen_context: { karte: "schritt", familie: "mac" },
  screen_double_click: { karte: "schritt", familie: "mac" },
  screen_hotkey: { karte: "schritt", familie: "mac" },
  screen_list_apps: { karte: "schritt", familie: "mac" },
  screen_look: { karte: "schritt", familie: "mac" },
  screen_mouse_click: { karte: "schritt", familie: "mac" },
  screen_mouse_move: { karte: "schritt", familie: "mac" },
  screen_right_click: { karte: "schritt", familie: "mac" },
  screen_scroll: { karte: "schritt", familie: "mac" },
  screen_take_screenshot: { karte: "schritt", familie: "mac" },
  screen_type_text: { karte: "schritt", familie: "mac" },
  send_mail: { karte: "karte", familie: "mail" },
  sheets_append_row: { karte: "karte", familie: "datei" },
  sheets_delete_row: { karte: "karte", familie: "datei" },
  sheets_find: { karte: "schritt", familie: "datei" },
  sheets_insert_row: { karte: "karte", familie: "datei" },
  sheets_read: { karte: "schritt", familie: "datei" },
  sheets_update_cell: { karte: "karte", familie: "datei" },
  shell_exec: { karte: "schritt", familie: "shell" },
  shorts_anlegen: { karte: "karte", familie: "medien" },
  shorts_marken: { karte: "schritt", familie: "medien" },
  shorts_neu: { karte: "karte", familie: "medien" },
  shorts_status: { karte: "karte", familie: "medien" },
  shorts_vorgaben: { karte: "schritt", familie: "medien" },
  shorts_vorlegen: { karte: "karte", familie: "medien" },
  show_map: { karte: "karte", familie: "reise" },
  stammdaten_merken: { karte: "schritt", familie: "gedaechtnis" },
  stammdaten_vergessen: { karte: "schritt", familie: "gedaechtnis" },
  stimme_benennen: { karte: "schritt", familie: "einstellung" },
  stimmung_verlauf: { karte: "karte", familie: "koerper" },
  tagesabsicht_setzen: { karte: "schritt", familie: "gedaechtnis" },
  task_cancel: { karte: "karte", familie: "system" },
  task_delegate: { karte: "karte", familie: "system" },
  task_laeufe: { karte: "schritt", familie: "system" },
  task_list: { karte: "karte", familie: "system" },
  telegram_nachricht: { karte: "schritt", familie: "system" },
  thread_close: { karte: "stumm", familie: "gedaechtnis" },
  thread_list: { karte: "stumm", familie: "gedaechtnis" },
  thread_open: { karte: "stumm", familie: "gedaechtnis" },
  ticket_apply: { karte: "karte", familie: "ticket" },
  ticket_create: { karte: "karte", familie: "ticket" },
  ticket_frage_beantworten: { karte: "karte", familie: "ticket" },
  ticket_get: { karte: "stumm", familie: "ticket" },
  ticket_link: { karte: "schritt", familie: "ticket" },
  ticket_list_open: { karte: "schritt", familie: "ticket" },
  ticket_offene_fragen: { karte: "karte", familie: "ticket" },
  ticket_roadmap: { karte: "schritt", familie: "ticket" },
  ticket_selbsttests: { karte: "schritt", familie: "ticket" },
  ticket_update: { karte: "stumm", familie: "ticket" },
  timer_local: { karte: "karte", familie: "kalender" },
  training_eintragen: { karte: "karte", familie: "koerper" },
  training_plan_aendern: { karte: "karte", familie: "koerper" },
  training_plan_zeigen: { karte: "karte", familie: "koerper" },
  trello_board_status: { karte: "karte", familie: "verwaltung" },
  trello_create_board: { karte: "karte", familie: "verwaltung" },
  trello_create_card: { karte: "karte", familie: "verwaltung" },
  trello_list_boards: { karte: "karte", familie: "verwaltung" },
  trello_list_cards: { karte: "karte", familie: "verwaltung" },
  trello_move_card: { karte: "karte", familie: "verwaltung" },
  unterkunft_zeigen: { karte: "karte", familie: "reise" },
  user_create: { karte: "karte", familie: "einstellung" },
  user_location_get: { karte: "schritt", familie: "reise" },
  vespera_ausliefern: { karte: "karte", familie: "system" },
  vespera_testflight: { karte: "karte", familie: "system" },
  vocab_add: { karte: "karte", familie: "lernen" },
  vocab_due: { karte: "karte", familie: "lernen" },
  vocab_result: { karte: "karte", familie: "lernen" },
  vocab_stats: { karte: "karte", familie: "lernen" },
  voice_memo_save: { karte: "karte", familie: "datei" },
  vorschlag_verwerfen: { karte: "schritt", familie: "einstellung" },
  weather: { karte: "karte", familie: "reise" },
  web_image_search: { karte: "karte", familie: "web" },
  web_search: { karte: "karte", familie: "web" },
  webseite_auftrag: { karte: "karte", familie: "webseite" },
  webseite_auftrag_stand: { karte: "schritt", familie: "webseite" },
  webseite_auftrag_wiederholen: { karte: "karte", familie: "webseite" },
  webseite_liste: { karte: "schritt", familie: "webseite" },
  webseite_status: { karte: "schritt", familie: "webseite" },
  webseite_veroeffentlichen: { karte: "karte", familie: "webseite" },
  webseite_versionen: { karte: "schritt", familie: "webseite" },
  webseite_zurueckrollen: { karte: "karte", familie: "webseite" },
  werkzeug_paket_anfordern: { karte: "schritt", familie: "system" },
  werkzeug_pruefen: { karte: "schritt", familie: "shell" },
  whoop_vitals: { karte: "karte", familie: "koerper" },
  zugangswerte_vorlegen: { karte: "karte", familie: "einstellung" },
};
